import styled from 'styled-components';
import { ReactComponent as SettingsIcon } from '@elementary/common-ui/assets/20x20/settings.svg';

const WidgetSettingsIcon = styled(SettingsIcon)`
  ${({ theme }) =>
    theme.tokens.components.iconButton.solidSettingsIcon &&
    '[opacity] { opacity: 1; }'}
`;

export default WidgetSettingsIcon;
